import { fontFamily } from '@atlaskit/theme';
export const charlieDisplayFontFamily = {
  fontFamily: "Charlie Display, ".concat(fontFamily())
};
export const charlieTextFontFamily = {
  fontFamily: "Charlie Text, ".concat(fontFamily())
};